import { z } from 'zod';

/**
 * Зеркало enum'ов из packages/db/prisma/schema.prisma.
 *
 * Дублирование намеренное: этот пакет тянет фронт, а @support/db тянет
 * Prisma Client — тащить его в браузерный бандл ради восьми строковых
 * литералов нельзя. Значения обязаны совпадать со схемой; при правке enum'а
 * в schema.prisma правится и здесь.
 */

export const ROLES = ['OWNER', 'ADMIN', 'SUPERVISOR', 'AGENT', 'VIEWER'] as const;
export const roleSchema = z.enum(ROLES);
export type Role = z.infer<typeof roleSchema>;

/** Старшинство ролей для проверок «не ниже чем». Больше — больше прав. */
export const ROLE_RANK: Record<Role, number> = {
  VIEWER: 0,
  AGENT: 1,
  SUPERVISOR: 2,
  ADMIN: 3,
  OWNER: 4,
};

export const USER_STATUSES = ['ACTIVE', 'INVITED', 'DISABLED'] as const;
export const userStatusSchema = z.enum(USER_STATUSES);
export type UserStatus = z.infer<typeof userStatusSchema>;

export const BOT_KINDS = ['SUPPORT', 'OPERATOR'] as const;
export const botKindSchema = z.enum(BOT_KINDS);
export type BotKind = z.infer<typeof botKindSchema>;

export const BOT_MODES = ['WEBHOOK', 'POLLING', 'DISABLED'] as const;
export const botModeSchema = z.enum(BOT_MODES);
export type BotMode = z.infer<typeof botModeSchema>;

export const BIND_SOURCES = ['DEEPLINK', 'TG_ID', 'MANUAL'] as const;
export const bindSourceSchema = z.enum(BIND_SOURCES);
export type BindSource = z.infer<typeof bindSourceSchema>;

export const CONVERSATION_STATUSES = [
  'NEW',
  'OPEN',
  'PENDING',
  'QUALIFIED',
  'CLOSED',
  'BLOCKED',
] as const;
export const conversationStatusSchema = z.enum(CONVERSATION_STATUSES);
export type ConversationStatus = z.infer<typeof conversationStatusSchema>;

export const DIRECTIONS = ['IN', 'OUT'] as const;
export const directionSchema = z.enum(DIRECTIONS);
export type Direction = z.infer<typeof directionSchema>;

export const AUTHOR_TYPES = ['CONTACT', 'OPERATOR', 'SYSTEM', 'AUTOMATION'] as const;
export const authorTypeSchema = z.enum(AUTHOR_TYPES);
export type AuthorType = z.infer<typeof authorTypeSchema>;

export const MESSAGE_KINDS = [
  'TEXT',
  'PHOTO',
  'VIDEO',
  'ANIMATION',
  'DOCUMENT',
  'VOICE',
  'AUDIO',
  'STICKER',
  'LOCATION',
  'CONTACT',
  'SYSTEM',
  'UNSUPPORTED',
] as const;
export const messageKindSchema = z.enum(MESSAGE_KINDS);
export type MessageKind = z.infer<typeof messageKindSchema>;

/** Виды с файлом: только для них заводится Attachment и работает media-воркер. */
export const MEDIA_MESSAGE_KINDS = [
  'PHOTO',
  'VIDEO',
  'ANIMATION',
  'DOCUMENT',
  'VOICE',
  'AUDIO',
  'STICKER',
] as const satisfies readonly MessageKind[];

export function isMediaKind(kind: MessageKind): boolean {
  return (MEDIA_MESSAGE_KINDS as readonly MessageKind[]).includes(kind);
}

export const SEND_STATUSES = ['QUEUED', 'SENT', 'FAILED'] as const;
export const sendStatusSchema = z.enum(SEND_STATUSES);
export type SendStatus = z.infer<typeof sendStatusSchema>;

export const ATTACHMENT_STATUSES = ['PENDING', 'READY', 'FAILED'] as const;
export const attachmentStatusSchema = z.enum(ATTACHMENT_STATUSES);
export type AttachmentStatus = z.infer<typeof attachmentStatusSchema>;

export const AUTOMATION_TRIGGERS = [
  'MESSAGE_RECEIVED',
  'CONVERSATION_CREATED',
  'EVENT_RECEIVED',
  'CONVERSATION_IDLE',
  'SCHEDULE',
] as const;
export const automationTriggerSchema = z.enum(AUTOMATION_TRIGGERS);
export type AutomationTrigger = z.infer<typeof automationTriggerSchema>;
